module.exports = __webpack_public_path__ + "static/img/Opportunities_EnjoyingLA_Pop_Venues.b3fa705.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Opportunities_EnjoyingLA_Pop_Venues.jpg
// module id = k4aF
// module chunks = 1